import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Stack, Typography } from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';
import DeleteIcon from '@mui/icons-material/Delete';

const DeleteConfirmationDialog = ({
  open,
  title = 'Confirm Delete',
  message,
  itemName,
  itemToDelete,
  onClose,
  onConfirm,
  confirmButtonText = 'Delete',
  showDeleteIcon = true,
  maxWidth = 'sm',
  fullWidth = true,
}) => {
  const displayTitle = title;
  const displayMessage = message || 'Are you sure you want to delete';
  const displayItemName = itemName || itemToDelete?.full_name || itemToDelete?.name || '';
  const displayConfirmText = confirmButtonText;

  return (
    <Dialog open={open} onClose={onClose} maxWidth={maxWidth} fullWidth={fullWidth}>
      <DialogTitle>
        <Stack direction="row" alignItems="center" spacing={1}>
          <WarningIcon color="warning" />
          <Typography>{displayTitle}</Typography>
        </Stack>
      </DialogTitle>
      <DialogContent>
        <Typography>
          {displayMessage} <strong>{displayItemName}</strong>? This action cannot be undone.
        </Typography>
        {itemToDelete && (
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
            This action cannot be undone. The item will be removed from the system.
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          variant="contained"
          color="error"
          onClick={onConfirm}
          startIcon={showDeleteIcon ? <DeleteIcon /> : null}
        >
          {displayConfirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirmationDialog;
